import { forwardRef } from 'react';

import ShareCurrentUrl from 'components/elements/shareCurrentUrl';
import { useOwnTranslate } from 'lib/hooks/useOwnTranslate';
import momentJalali from 'lib/utils/helpers/momentJalali';
import useHPIDetail from '../hooks/useHPIDetail';

const HousePricesDetailInfo = forwardRef<HTMLDivElement>((props, _ref) => {
  const { t } = useOwnTranslate();
  const { seo, marketStat } = useHPIDetail({city:undefined,region:undefined});
  const { title } = { ...seo?.seo }
  return (
    <>
      <div
        className="flex lg:flex-row flex-col justify-between items-start lg:gap-6 gap-5"
        ref={_ref}
      >
        <div className="flex flex-col lg:gap-6 gap-5">
          <h1 className="lg:text-display-sm text-display-xs font-semiBold">
            {title}
          </h1>
          {marketStat && (
            <p className="lg:text-xl text-grey-500">
              {t('global.lastEval', true, {
                date: momentJalali(
                  new Date(marketStat.lastUpdateDate)
                ).fromNow(),
              })}
            </p>
          )}
        </div>
        <ShareCurrentUrl />
      </div>
    </>
  );
});

HousePricesDetailInfo.displayName = 'InstantValuationDetailInfo';

export default HousePricesDetailInfo;
